import { ReactComponent as IconMail } from "assets/images/icons/mail.svg";
import Panel from "pages/Dashboard/Panel";
import MessageBoxTeaser from "pages/MessageBox/MessageBoxTeaser";
import useViewData from "features/view/hooks/useViewData";
import Alert from "components/ui/Alert/Alert";

function MessageBoxPanel() {
  const { view, isLoading } = useViewData("conversation/summary");
  let content;
  if (!isLoading) {
    if (view?.results) {
      content = view.results
        .map((message) => {
          const profile = view.refs.profile.find(
            (profile) => parseInt(message.sender_uid) === profile.uid
          );

          if (!profile) {
            return null;
          }

          return (
            <MessageBoxTeaser
              key={message.id}
              profile={profile}
              created={message.created}
              message={message.message}
              image={message.image}
              isRead={message.unread !== "1"}
            />
          );
        })
        .filter(Boolean);

      if (view.results.length === 0) {
        content = <div>U heeft nog geen berichten ontvangen.</div>;
      }
    } else {
      content = <Alert message={`Het ophalen van de berichten is mislukt.`} />;
    }
  }

  return (
    <Panel
      title={"Mijn berichtenbox"}
      id={"messages"}
      showAllPath={"/berichtenbox"}
      linkLabel={"Alle berichten"}
      icon={<IconMail />}
      hasContentBackground={true}
    >
      {content}
    </Panel>
  );
}

export default MessageBoxPanel;
